module.exports = __webpack_public_path__ + "img/full-width.891492eb.svg";